import { useEffect, useState } from "react";
import DotLoader from "./DotLoader.tsx";

/**
 * Useful for covering loads that might finish quickly. The UI can feel
 * snappier if you omit the loader in those cases.
 */
export default function DelayedDotLoader({
  className,
}: {
  className?: string;
}) {
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      setShowLoader(true);
    }, 250);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, []);

  if (showLoader) {
    return <DotLoader className={className} />;
  }
  return null;
}
